<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>جزئیات پیگیری</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>

            <div class="card card-style bg-theme pb-0">
                <div class="content">
                    <ul class="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
                        <li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-details');">
                            <button class="nav-link text-center rounded-s w-100 taskWorkTab-btn" :class="{'active':activeTabTitle=='#pills-details'}" id="pills-details-tab" data-toggle="pill" data-target="#pills-details" role="tab" aria-controls="pills-details" aria-selected="true" style="border: 1px solid #007bff">جزئیات</button>
                        </li>
                        <li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-taskInfo');">
                            <button class="nav-link text-center rounded-0 w-100 taskWorkTab-btn" :class="{'active':activeTabTitle=='#pills-taskInfo'}" id="pills-taskInfo-tab" data-toggle="pill" data-target="#pills-taskInfo" role="tab" aria-controls="pills-taskInfo" aria-selected="false" style="border: 1px solid #007bff">{{lableText('TaskName')??'وظیفه'}}</button>
                        </li>
                        <li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-timeLine');">
                            <button class="nav-link text-center rounded-0 w-100 taskWorkTab-btn" :class="{'active':activeTabTitle=='#pills-timeLine'}" id="pills-timeLine-tab" data-toggle="pill" data-target="#pills-timeLine" role="tab" aria-controls="pills-timeLine" aria-selected="false" style="border: 1px solid #007bff">سیر زمانی</button>
                        </li>
                        <li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-presenceInfo');">
                            <button class="nav-link text-center rounded-0 w-100 taskWorkTab-btn" :class="{'active':activeTabTitle=='#pills-presenceInfo'}" id="pills-presenceInfo-tab" data-toggle="pill" data-target="#pills-presenceInfo" role="tab" aria-controls="pills-presenceInfo" aria-selected="false" style="border: 1px solid #007bff">جزئیات حضوروغیاب</button>
                        </li>
                        <li class="nav-item flex-1" role="presentation" @click="onTabClick('pills-taskworklist');">
                            <button class="nav-link text-center rounded-s w-100 taskWorkTab-btn" :class="{'active':activeTabTitle=='#pills-taskworklist'}" id="pills-taskworklist-tab" data-toggle="pill" data-target="#pills-taskworklist" role="tab" aria-controls="pills-taskworklist" aria-selected="false" style="border: 1px solid #007bff">پیگیری‌ها</button>
                        </li>
                    </ul>
                    <div class="tab-content mt-4" id="pills-tabContent">
                        <div class="tab-pane fade active show" id="pills-details" :class="{'active show':activeTabTitle=='#pills-details'}" role="tabpanel" aria-labelledby="pills-details-tab">
                            <div class="mb-0">
                                <div class="input-style input-style-2 has-icon input-required">
                                    <i class="input-icon fa fa-hashtag brand-color"></i>
                                    <span class="color-highlight" :class="{'input-style-1-active' : taskWorkModel.workNo!==null}">شماره پیگیری</span>
                                    <input readonly class="form-control ltr d-inline-block" type="text" v-model="taskWorkModel.workNo" @input="v$.taskWorkModel.workNo.$touch()" :class="{invalid:v$.taskWorkModel.workNo.$error}">
                                    <p class="text-danger" v-if="v$.taskWorkModel.workNo.required.$invalid && v$.taskWorkModel.workNo.$dirty">شماره پیگیری وارد نشده است</p>
                                </div>

                                <div>
                                    <div class="input-style input-style-2 has-icon input-required mb-3">
                                        <i class="input-icon fa fa-calendar-times brand-color"></i>
                                        <span class="color-highlight" :class="{'input-style-1-active' : taskWorkModel.workDate!==null}">تاریخ پیگیری</span>
                                        <input type="text" class="form-control ltr d-inline-block" v-model="taskWorkModel.workDate" id="workd" @input="v$.taskWorkModel.workDate.$touch()" :class="{invalid:v$.taskWorkModel.workDate.$error}" />
                                    </div>
                                    <date-picker type="date" v-model="taskWorkModel.workDate" format="jYYYY/jMM/jDD" element="workd" />
                                    <p class="text-danger" v-if="v$.taskWorkModel.workDate.required.$invalid && v$.taskWorkModel.workDate.$dirty">لطفا تاریخ پیگیری را وارد کنید.</p>

                                </div>

                                <div class="input-style input-style-2 has-icon input-required">
                                    <i class="input-icon fa fa-check brand-color"></i>
                                    <span class="color-highlight" :class="{'input-style-1-active' : taskWorkModel.title!==null}">عنوان</span>
                                    <input class="form-control" type="text" v-model="taskWorkModel.title" @input="v$.taskWorkModel.title.$touch()" :class="{invalid:v$.taskWorkModel.title.$error}" @keyup="modified=true">
                                    <p class="text-danger" v-if="v$.taskWorkModel.title.required.$invalid && v$.taskWorkModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                                </div>
                                <div class="mb-4">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="d-flex align-items-center">
                                            <i class="fa fa-clock pl-2 brand-color"></i>
                                            <label class="mb-0 font-12 font-weight-bold">زمان استفاده شده</label>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
                                                <span class="font-13 font-weight-bold px-3"></span>
                                                <label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
                                            </div>
                                            <div class="ltr">
                                                <input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:70px" type="tel" v-model="taskWorkModel.workUsedTimeHour" @input="v$.taskWorkModel.workUsedTimeHour.$touch()" :class="{invalid:v$.taskWorkModel.workUsedTimeHour.$error}">
                                                <span class="font-13 font-weight-bold px-3">:</span>
                                                <input placeholder="00" @input="() => { if(taskWorkModel.workUsedTimeMinute  > 59 || taskWorkModel.workUsedTimeMinute  < 0) { taskWorkModel.workUsedTimeMinute = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:70px" type="tel" v-model="taskWorkModel.workUsedTimeMinute" :class="{invalid:v$.taskWorkModel.workUsedTimeMinute.$error}">
                                            </div>
                                        </div>
                                    </div>
                                    <p class="text-danger mt-2" v-if="v$.taskWorkModel.workUsedTimeHour.between.$invalid && v$.taskWorkModel.workUsedTimeHour.$dirty">ساعت باید مقداری از ۰ تا ۱۰۰۰ داشته باشد.</p>
                                    <p class="text-danger mt-2" v-if="v$.taskWorkModel.workUsedTimeMinute.between.$invalid && v$.taskWorkModel.workUsedTimeMinute.$dirty">دقیقه باید مقداری از ۰ تا ۵۹ داشته باشد.</p>

                                </div>

                                <div>
                                    <div class="input-style input-style-2 has-icon input-required">
                                        <i class="input-icon fa fa-calendar-check brand-color"></i>
                                        <span class="color-highlight" :class="{'input-style-1-active' : taskWorkModel.fllowUpDateTime!==null}">تاریخ و ساعت پیگیری بعدی</span>
                                        <input type="text" class="form-control ltr d-inline-block" v-model="taskWorkModel.fllowUpDateTime" id="endDT" />
                                    </div>
                                    <date-picker type="datetime" v-model="taskWorkModel.fllowUpDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="endDT" :jumpMinute="5" />

                                </div>

                                <div class="input-style input-style-2 has-icon input-required">
                                    <i class="input-icon fa fa-check brand-color"></i>
                                    <span class="color-highlight">عنوان پیگیری بعدی</span>
                                    <input class="form-control" type="text">
                                </div>

                                <div class="mb-3">
                                    <v-select v-if="taskWorkModel.taskId!=null" dir="rtl" label="title" placeholder="آخرین وضعیت" :filterable="false" :searchable="false" :options="taskTypeStepList" :reduce="p => p.taskTypeStepId" v-model="taskWorkModel.taskTypeStepId">
                                        <template slot="option">
                                            <div class="d-center">
                                                {{ option.title }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>

                                <div class="mb-3">
                                    <label>درصد پیشرفت: <span class="badge bg-green1-dark font-14">{{taskWorkModel.progressRate}} %</span></label>
                                    <div class="range-slider bottom-15">
                                        <input class="ios-slider" type="range" min="1" max="100" v-model=taskWorkModel.progressRate>
                                    </div>
                                </div>


                                <div class="mb-2">
                                    <!--<div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                                        <a class="pr-1" data-toggle="collapse" href="#collapse-description">
                                            <i class="fa fa-edit mt-2"></i>
                                            <span>توضیحات</span>
                                            <i class="fa fa-angle-down"></i>
                                        </a>
                                    </div>-->
                                    <div>
                                        <div v-if="taskWorkModel.editable==false" class="form-control font-12 line-height-m text-justify div-description" v-html="taskWorkModel.description" style="height:200px" readonly></div>
                                        <textarea v-if="taskWorkModel.editable" v-model="taskWorkModel.description" class="form-control line-height-m text-justify" rows="3" style="height:200px" @keyup="modified=true" placeholder="توضیحات"></textarea>

                                    </div>
                                </div>
                                <button v-if="taskWorkModel.editable" class="btn btn-link speechToTextBtn mb-3" @pointerdown="startR" @pointerup="stopR">
                                    <span :class="btnRecord">
                                        <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                                    </span>
                                    <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                                </button>
                                <!--<div class="input-style input-style-2 has-icon input-required mt-0">
                                    <i class="input-icon fa fa-edit brand-color"></i>
                                    <span class="color-highlight input-style-1-active">توضیحات</span>
                                    <div v-if="taskWorkModel.editable==false" class="form-control font-12 line-height-m text-justify div-description" v-html="taskWorkModel.description" style="height:200px" readonly></div>
                                    <textarea v-if="taskWorkModel.editable" v-model="taskWorkModel.description" class="form-control line-height-m text-justify" rows="3" style="height:200px" @input="v$.taskWorkModel.description.$touch()" :class="{invalid:v$.taskWorkModel.description.$error}"></textarea>
                                    <p class="text-danger" v-if="v$.taskWorkModel.description.required.$invalid && v$.taskWorkModel.description.$dirty">لطفا توضیحات را وارد کنید.</p>
                                </div>-->

                                <taskfolderitem-list v-if="taskWorkModel.taskId!=null" :taskId="taskWorkModel.taskId" :taskFolderId="taskWorkModel.taskFolderId" :readOnly="taskWorkModel.readOnlyFolderItem"></taskfolderitem-list>

                                <att-list :docId="0" v-if="taskWorkModel.workNo!=null" v-bind:destination="'TaskWork'" @setAttList="SetAttList($event)" @attInProgress="AttInProgress($event)" :canAdd="taskWorkModel.editable" :canDelete="taskWorkModel.editable" :oldAttList="taskWorkModel.attList" :hasLocation="true"></att-list>

                                <button v-if="taskWorkModel.editable" :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="EditTaskWork">
                                    <i class="fa fa-check font-10 ml-2"></i>
                                    ثبت
                                </button>
                            </div>

                        </div>
                        <div class="tab-pane fade" id="pills-taskInfo" :class="{'active show':activeTabTitle=='#pills-taskInfo'}" role="tabpanel" aria-labelledby="pills-taskInfo-tab">
                            <task-info v-if="taskWorkModel.taskId!=null" :taskId="taskWorkModel.taskId" :taskFolderId="taskWorkModel.taskFolderId"></task-info>
                        </div>
                        <div class="tab-pane fade" id="pills-timeLine" :class="{'active show':activeTabTitle=='#pills-timeLine'}" role="tabpanel" aria-labelledby="pills-timeLine-tab">
                            <task-time-line v-if="taskWorkModel.taskId!=null" :taskId="taskWorkModel.taskId" :taskFolderId="taskWorkModel.taskFolderId" :hideDetailsButton="true"></task-time-line>
                        </div>

                        <div class="tab-pane fade active" id="pills-presenceInfo" :class="{'active show':activeTabTitle=='#pills-presenceInfo'}" role="tabpanel" aria-labelledby="pills-presenceInfo-tab">
                            <!--مستندات حضور و غیاب-->
                            <div class="mb-3">
                                <div class="d-flex mb-3">
                                    <div class="w-100">
                                        <v-select dir="rtl" v-model="taskWorkModel.arrivalUserPresenceId" @option:selected="onchangeUserPresenceArrival(false)" @option:cleared="onClearedUserPresenceArrival" label="fullTitle" :filter="UserPresenceArrivalFilter" placeholder="زمان ورود" :options="UserPresenceArrivalListForRef" :reduce="p => p.userPresenceId">
                                            <template v-slot="option">
                                                <div class="d-center">
                                                    <span>{{  option.fullTitle }}</span>
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                    <button class="btn btn-xxs rounded-sm btn-primary btnNexInput" @click="ShowCreateLocationModal">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                    <button class="btn btn-xxs rounded-sm btn-success btnNexInput" @click="onchangeUserPresenceArrival(true)">
                                        <i class="fa fa-sync"></i>
                                    </button>
                                </div>
                                <div v-if="ShowArrivalUserPresenceInfo">
                                    <div>
                                        <div class="mb-4">
                                            <l-map style="height:300px" :zoom="16" :center="mapLocationObjectArrival" v-if="mapLocationObjectArrival!=null">
                                                <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                                                <l-marker :lat-lng="mapLocationObjectArrival"></l-marker>
                                            </l-map>
                                        </div>
                                    </div>
                                    <div>
                                        <textarea readonly v-model="arrivalUserPresenceAddress" placeholder="آدرس ورود" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:100px"></textarea>
                                    </div>
                                    <div>
                                        <button type="button" class="btn btn-xxs mt-3 mb-3 btn-full bg-green2-dark rounded-sm font-900 w-100" @click="showMapLocation(false)"><i class="fa fa-map-marked font-10 ml-2"></i>نمایش موقعیت روی نقشه</button>
                                    </div>
                                </div>
                            </div>


                            <div class="mb-3">
                                <div class="d-flex mb-3">
                                    <div class="w-100">
                                        <v-select dir="rtl" v-model="taskWorkModel.departureUserPresenceId" @option:selected="onchangeUserPresenceDeparture(false)" label="fullTitle" :filter="UserPresenceDepartureFilter" placeholder="زمان خروج" :options="UserPresenceDepartureListForRef" :reduce="p => p.userPresenceId">
                                            <template v-slot="option">
                                                <div class="d-center">
                                                    <span>{{  option.fullTitle }}</span>
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                    <button class="btn btn-xxs rounded-sm btn-primary btnNexInput" @click="ShowCreateLocationModal">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                    <button class="btn btn-xxs rounded-sm btn-success btnNexInput" @click="onchangeUserPresenceDeparture(true)">
                                        <i class="fa fa-sync"></i>
                                    </button>
                                </div>
                                <div v-if="ShowDepartureUserPresenceInfo">
                                    <div>
                                        <div class="mb-4">
                                            <l-map style="height:300px" :zoom="16" :center="mapLocationObjectDeparture" v-if="mapLocationObjectDeparture!=null">
                                                <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                                                <l-marker :lat-lng="mapLocationObjectDeparture"></l-marker>
                                            </l-map>
                                        </div>
                                    </div>
                                    <div>
                                        <textarea readonly v-model="departureUserPresenceAddress" placeholder="آدرس خروج" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:100px"></textarea>
                                    </div>
                                    <div>
                                        <button type="button" class="btn btn-xxs mt-3 mb-3 btn-full bg-green2-dark rounded-sm font-900 w-100" @click="showMapLocation(true)"><i class="fa fa-map-marked font-10 ml-2"></i>نمایش موقعیت روی نقشه</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="tab-pane fade" id="pills-taskworklist" :class="{'active show':activeTabTitle=='#pills-taskworklist'}" role="tabpanel" aria-labelledby="pills-taskworklist-tab">
                            <task-work-list v-if="taskWorkModel.taskId!=null" :taskId="taskWorkModel.taskId" :taskFolderId="taskWorkModel.taskFolderId" :hideDetailsButton="true"></task-work-list>

                        </div>
                    </div>
                </div>
            </div>


        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید...</div>
            </div>
        </transition>
        <create-Location-Modal v-if="openCreateLocationModal" :defaultLocation="null" :defaultAddress="null" @close="CloseCreateLocationModal"></create-Location-Modal>

    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required, between
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';
    import taskInfo from './TaskInfo.vue';
    import timeLine from './TimeLine.vue'
    import taskWorkList from './TaskWorkList.vue'
    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from 'vue3-simple-alert';
    import TaskFolderItemList from './TaskFolderItemList.vue';
    import CreateLocationModal from '../Components/CreateLocationModal.vue';

    import { LMap, LMarker, LTileLayer } from "@vue-leaflet/vue-leaflet";
    import "leaflet/dist/leaflet.css"
    import { latLng } from "leaflet";


    import { Icon } from 'leaflet';

    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });


    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
    export default {
        components: {
            DatePicker,
            "att-list": AttList,
            "task-info": taskInfo,
            "task-time-line": timeLine,
            "task-work-list": taskWorkList,
            "taskfolderitem-list": TaskFolderItemList,
            "create-Location-Modal": CreateLocationModal,
            "l-map": LMap,
            "l-tile-layer": LTileLayer,
            "l-marker": LMarker
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                activeTabTitle: "#pills-details",
                attInProgress: false,
                modified: false,
                showType: false,

                openCreateLocationModal: false,

                ShowArrivalUserPresenceInfo: false,
                arrivalUserPresenceAddress: "",
                mapLocationArrival: "",
                mapLocationObjectArrival: null,


                ShowDepartureUserPresenceInfo: false,
                departureUserPresenceAddress: "",
                mapLocationDeparture: "",
                mapLocationObjectDeparture: null,


                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",
                taskWorkModel: {
                    workNo: null,
                    workDate: null,
                    taskWorkId: null,
                    taskId: null,
                    taskFolderId: this.$route.params.taskFolderId,
                    workPercent: 0,
                    workUsedTime: null,
                    fllowUpDateTime: null,
                    fllowUpTime: null,
                    title: null,
                    userId: 0,
                    progressRate: null,
                    description: null,
                    attList: [],
                    editable: false,
                    taskNo: null,
                    taskTitle: null,
                    taskTypeStepId: null,
                    readOnlyFolderItem: false,
                    workUsedTimeMinute: null,
                    workUsedTimeHour: null,

                    isForMe: true,
                    departureUserPresenceId: null,
                    arrivalUserPresenceId: null,
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            taskTypeStepList() {
                return this.$store.getters.GetTaskTypeStepList;
            },
            UserPresenceDepartureListForRef() {
                return this.$store.getters.GetDepartureListForRef;
            },
            UserPresenceArrivalListForRef() {
                return this.$store.getters.GetArrivalListForRef;
            },
        },
        created() {
            this.GetTaskWorkItem();
            this.modified = false;


        },

        methods: {
            ShowCreateLocationModal() {
                this.openCreateLocationModal = true;
            },
            CloseCreateLocationModal() {
                this.openCreateLocationModal = false;
            },

            UserPresenceArrivalFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetArrivalListForRef", {
                        text: queryText,
                        data: this.taskWorkModel.workDate

                    });
                return this.$store.getters.GetArrivalListForRef;
            },
            onchangeUserPresenceArrival(isReload = false) {
                if (isReload) {
                    this.taskWorkModel.arrivalUserPresenceId = null;
                    this.$store.dispatch("GetArrivalListForRef", {
                        data: this.taskWorkModel.workDate
                    });
                }
                this.taskWorkModel.departureUserPresenceId = null;
                this.ShowDepartureUserPresenceInfo = false;
                if (this.taskWorkModel.arrivalUserPresenceId != null) {
                    this.$store.dispatch("GetDepartureListForRef", {
                        data: this.taskWorkModel.workDate,
                        removedId: this.taskWorkModel.arrivalUserPresenceId,
                    });
                }

                this.ShowArrivalUserPresenceInfo = false;
                if (this.taskWorkModel.arrivalUserPresenceId != null) {
                    this.ShowArrivalUserPresenceInfo = true;
                    this.$http.get("UserPresence/GetUserPresenceItem?id=" + this.taskWorkModel.arrivalUserPresenceId)
                        .then(data => {
                            this.arrivalUserPresenceAddress = data.data.address;
                            var m = data.data.mapLocation.split(',');
                            this.mapLocationObjectArrival = latLng(m[0], m[1]);
                            this.mapLocationArrival = data.data.mapLocation;
                        });
                }
                setTimeout(function () {
                    document.getElementById("pills-presenceInfo").classList.remove("active")
                }, 3000)
            },
            onClearedUserPresenceArrival() {
                this.taskWorkModel.departureUserPresenceId = null;
            },

            UserPresenceDepartureFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetDepartureListForRef", {
                        text: queryText,
                        data: this.taskWorkModel.workDate

                    });
                return this.$store.getters.GetDepartureListForRef;
            },
            onchangeUserPresenceDeparture(isReload = false) {
                if (isReload) {
                    this.taskWorkModel.departureUserPresenceId = null;
                    this.$store.dispatch("GetDepartureListForRef", {
                        data: this.taskWorkModel.workDate,
                        removedId: this.taskWorkModel.arrivalUserPresenceId,
                    });
                }
                this.ShowDepartureUserPresenceInfo = false;
                if (this.taskWorkModel.departureUserPresenceId != null) {
                    this.ShowDepartureUserPresenceInfo = true;
                    this.$http.get("UserPresence/GetUserPresenceItem?id=" + this.taskWorkModel.departureUserPresenceId)
                        .then(data => {
                            this.departureUserPresenceAddress = data.data.address;
                            var m = data.data.mapLocation.split(',');
                            this.mapLocationObjectDeparture = latLng(m[0], m[1]);
                            this.mapLocationDeparture = data.data.mapLocation;
                        });
                }
            },
            showMapLocation(isDeparture) {
                // If it's an iPhone..
                if (isDeparture) {
                    if ((navigator.platform.indexOf("iPhone") != -1)
                        || (navigator.platform.indexOf("iPod") != -1)
                        || (navigator.platform.indexOf("iPad") != -1))
                        window.open("maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.mapLocationDeparture);
                    else
                        window.open("https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.mapLocationDeparture);
                } else {
                    if ((navigator.platform.indexOf("iPhone") != -1)
                        || (navigator.platform.indexOf("iPod") != -1)
                        || (navigator.platform.indexOf("iPad") != -1))
                        window.open("maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.mapLocationArrival);
                    else
                        window.open("https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.mapLocationArrival);
                }
            },
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }

            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            EditTaskWork() {
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.modified = false;
                    this.$store.dispatch("EditTaskWork", this.taskWorkModel);
                }

            },
            GetTaskWorkItem() {
                this.$http.get("TaskWork/EditTaskWork?id=" + this.$route.params.taskWorkId)
                    .then(data => {

                        this.modified = false;
                        this.$store.dispatch("GetTaskTypeStepListFromServer", { taskTypeId: this.taskWorkModel.taskId });
                        this.$store.dispatch("GetArrivalListForRef", {
                            data: data.data.workDate,
                            id: data.data.arrivalUserPresenceId,
                            isOnlyView: !this.isForMe,
                        }).then(l => {
                            this.$store.dispatch("GetDepartureListForRef", {
                                data: data.data.workDate,
                                removedId: data.data.arrivalUserPresenceId,
                                isOnlyView: !this.isForMe,
                                id: data.data.departureUserPresenceId
                            }).then(m => {
                                this.modified = false;
                                this.taskWorkModel = data.data;

                                if (data.fllowUpDateTime == " " || data.data.fllowUpDateTime == null) {

                                    this.taskWorkModel.fllowUpDateTime = null;

                                }

                                this.ShowArrivalUserPresenceInfo = false;
                                if (this.taskWorkModel.arrivalUserPresenceId != null) {
                                    this.ShowArrivalUserPresenceInfo = true;

                                    this.$http.get("UserPresence/GetUserPresenceItem?id=" + this.taskWorkModel.arrivalUserPresenceId)
                                        .then(data => {
                                            this.arrivalUserPresenceAddress = data.data.address;
                                            var m = data.data.mapLocation.split(',');
                                            this.mapLocationObjectArrival = latLng(m[0], m[1]);
                                            this.mapLocationArrival = data.data.mapLocation;
                                        });
                                }

                                if (this.taskWorkModel.departureUserPresenceId != null) {
                                    this.ShowDepartureUserPresenceInfo = true;
                                    this.$http.get("UserPresence/GetUserPresenceItem?id=" + this.taskWorkModel.departureUserPresenceId)
                                        .then(data => {
                                            this.departureUserPresenceAddress = data.data.address;
                                            var m = data.data.mapLocation.split(',');
                                            this.mapLocationObjectDeparture = latLng(m[0], m[1]);
                                            this.mapLocationDeparture = data.data.mapLocation;
                                        });
                                }

                            })
                        })
                    });
            },
            getTaskFolderData() {
                this.$http.get("TaskWork/GetInitData?taskFolderId=" + this.taskWorkModel.taskFolderId)

                    .then(data => {
                        this.taskWorkModel = data.data;
                        this.modified = false;
                    });

            },
            fixTime() {
                var val = this.taskWorkModel.workUsedTime;
                if (val.length == 1) {
                    val = '0' + val + ':00';
                }
                else if (val.length == 2) {
                    val = val + ':00';
                }
                else if (val.length == 3) {
                    val = val + '00';
                }
                else if (val.length == 4) {
                    val = val + '0';
                }
                this.taskWorkModel.workUsedTime = val;
                this.modified = false;
            },
            SetAttList(e) {
                console.log(e);
                this.taskWorkModel.attList = e;
                this.modified = false;
            },
            AttInProgress(e) {
                this.attInProgress = e;
            },
            onTabClick(title) {
                console.log(title);
                //window.location.href = "#" + title;
            }
        },
        mounted() {
            try {

                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");


                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.taskWorkModel.description == null || this.taskWorkModel.description == "null")
                        this.taskWorkModel.description = "";
                    if (rest != null && rest != '')
                        this.taskWorkModel.description = this.taskWorkModel.description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
                // Expected output: ReferenceError: nonExistentFunction is not defined
                // (Note: the exact output may be browser-dependent)
            }
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },
        validations: {
            taskWorkModel: {
                workNo: {
                    required,
                },
                workDate: {
                    required
                },
                title: {
                    required
                },
                progressRate: {
                    required
                },
                workUsedTimeMinute: {
                    between: between(0, 59)
                },
                workUsedTimeHour: {
                    between: between(0, 1000)
                },
            }
        },
        directives: { maska },
        beforeRouteLeave(to, from, next) {
            if (this.modified == true) {
                VueSimpleAlert.fire({
                    title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
                    showCancelButton: true,
                    confirmButtonText: 'تأیید',
                    cancelButtonText: `انصراف`,
                }).then((result) => {
                    console.log(this.modified);

                    if (result.value == true) {
                        next();
                    } else {
                        next(false);
                    }
                })
            }
            else {
                next();
            }
        }

    };
</script>
